module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-body"
  }, [_c('div', {
    staticClass: "outer-div outer-div-min"
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "grid-4"
  }, [_c('dropdown', {
    attrs: {
      "id": _vm.fileUploadId1,
      "list": _vm.periods,
      "defaultText": _vm.defaultText,
      "selectedItem": (_vm.gettersAggInputDataName.period) ? _vm.gettersAggInputDataName.period.name : ""
    },
    model: {
      value: (_vm.selectedPeriod),
      callback: function($$v) {
        _vm.selectedPeriod = $$v
      }
    }
  })], 1), _vm._v(" "), _c('div', {}, [_c('upload', {
    attrs: {
      "disabled": !_vm.selectedPeriod,
      "clearUploadButtonText": _vm.clearUploadButtonText,
      "period": _vm.selectedPeriod,
      "uploadFile": _vm.uploadFile
    }
  })], 1)])])]), _vm._v(" "), (_vm.uploadResult.mistake.length > 0) ? _c('error', {
    attrs: {
      "mistakes": _vm.uploadResult.mistake
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-27d9ac72!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/file-upload/FileUpload.vue
// module id = 359
// module chunks = 2